<header>
  <div id="logo">
    <img src="assets/logo-eazly.svg" alt="Logo de eazly">
  </div>
</header>
